module.exports = __webpack_public_path__ + "assets/img/ico-information.a9343106.svg";